import React, { useEffect, useState } from "react";
import { useNavigate} from "react-router-dom";
import API from "../services/api";
import "./Ngoaccount.css";

function NgoAccount() {
  const navigate = useNavigate();
  const [ngo, setNgo] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const email = localStorage.getItem("ngoEmail");

        if (!email) {
          navigate("/ngo/login");
          return;
        }

        const response = await API.get(`/ngo/profile?email=${email}`);

        setNgo(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchProfile();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  if (!ngo) return <h2>Loading...</h2>;

  return (
    <>
      <div className="ngo-account-page">
        <div className="ngo-account-card">
          <h2 className="ngo-account-title">
            Welcome {ngo.ngo_name}
          </h2>

          <div className="ngo-account-info">
            <div><span>Email:</span> {ngo.email}</div>
            <div><span>Phone:</span> {ngo.phone}</div>
            <div><span>Address:</span> {ngo.address}</div>
          </div>

          <button className="ngo-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </>
  );
}

export default NgoAccount;
